export default __webpack_public_path__ + "static/media/icons8-tesla-model-s.afa04aa9.svg";